import Component from "./GeneratePIN";
import { connect } from "react-redux";


export default connect(
    null,
    ({ scp: { addUser, deleteUser }, alert: { silence } }) => ({ addUser, deleteUser ,silence })
)(Component);
